export default __webpack_public_path__ + "static/media/eye-closed-icon.719b5349.svg";